(() => {
  const ready = () => {
    document.querySelectorAll('#MainContent a[href]').forEach(link => {
      try {
        const host = new URL(link.href, location.href).hostname;
        if (/(^|\.)(amazon\.[a-z.]+|amzn\.to)$/.test(host) && /btn|button|cta|purchase|buy/i.test(link.className)) link.classList.add('umlg-amazon-cta');
      } catch (_) {}
    });
    document.querySelectorAll('.product-details rte-formatter').forEach((root, index) => {
      const heading = root.querySelector('h2');
      if (!heading || heading.textContent.trim() !== 'Product details' || root.querySelector('.umlg-details-copy')) return;
      root.dataset.umlgMoreReady = 'true';
      const oldToggle = root.nextElementSibling;
      if (oldToggle?.classList.contains('umlg-description-toggle')) oldToggle.remove();
      const copy = document.createElement('div');
      copy.className = 'umlg-details-copy';
      copy.id = `umlg-details-copy-${index}`;
      [...root.childNodes].forEach(node => { if (node !== heading) copy.appendChild(node); });
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'umlg-details-toggle';
      toggle.textContent = 'See more';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', copy.id);
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        copy.classList.toggle('is-expanded', expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? 'See less' : 'See more';
      });
      root.append(copy, toggle);
      requestAnimationFrame(() => { toggle.hidden = copy.scrollHeight <= copy.clientHeight + 1; });
    });
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const main = document.getElementById('MainContent');
    if (!main) return;
    const sections = [...main.querySelectorAll('section')].filter(item => !item.querySelector('section'));
    const standalone = [...main.querySelectorAll('.product-information')].filter(item => !item.closest('section'));
    const fallback = [...main.children].filter(item => !item.querySelector('section, .product-information') && !item.matches('script, style, link'));
    const footer = document.getElementById('umlg-global-footer');
    const items = [...new Set([...sections, ...standalone, ...fallback, ...(footer ? [footer] : [])])];
    let observer;
    try {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('umlg-reveal-visible');
          observer.unobserve(entry.target);
        });
      }, {threshold: 0, rootMargin: '0px 0px -32px 0px'});
      items.forEach(item => {
        if (item.getBoundingClientRect().height === 0) return;
        item.classList.add('umlg-reveal');
        if (item.getBoundingClientRect().bottom <= 0) item.classList.add('umlg-reveal-visible');
        else observer.observe(item);
      });
      document.addEventListener('focusin', event => {
        const section = event.target.closest('.umlg-reveal');
        if (section) { section.classList.add('umlg-reveal-visible'); observer.unobserve(section); }
      });
      matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', event => {
        if (event.matches) items.forEach(item => item.classList.add('umlg-reveal-visible'));
      });
      addEventListener('beforeprint', () => items.forEach(item => item.classList.add('umlg-reveal-visible')));
    } catch (_) {
      items.forEach(item => item.classList.add('umlg-reveal-visible'));
      observer?.disconnect();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
})();